import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row } from 'antd';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router';
import config from '~/config';
import { checkKeyDownNumberInput } from '~/utils';
import styles from './LoginWithPass.module.scss';
import { useState } from 'react';
import NumberInput from './Numberinput';
const cx = classNames.bind(styles);

function LoginWithPass({ onFinish, form, msgError }) {
    const navigate = useNavigate();
    const checkUsername = (_, value) => {
        // if (value > 0) {
        //   return Promise.resolve();
        // }

        const regex = new RegExp(/(0[3|5|7|8|9])+([0-9])/);
        if (value.number.length == 10 && regex.test(value.number)) {
            return Promise.resolve();
        }
        if (value.number.length != 10 && value.number.length != 0) {
            return Promise.reject(new Error('Phone number must have 10 digits'));
        }
        if (!regex.test(value.number) && value.number.length != 0) {
            return Promise.reject(new Error('Wrong phone number format'));
        }
        if (value.number.length == 0) {
            return Promise.reject(new Error('Please enter a phone number'));
        }
    };
    return (
        <Form onFinish={onFinish} form={form}>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Log in
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')}>
                    Log in to track orders, save a list of favorite products, and receive many attractive offers.
                </Row>
            </Form.Item>
            {msgError && (
                <Row justify="center" className={cx('err')}>
                    {msgError}
                </Row>
            )}

            <Form.Item
                name="phone"
                rules={[
                    { required: true, message: 'Please enter phone number' },
                    {
                        validator: checkUsername,
                    },
                    // {
                    // message: 'Wrong phone number format',
                    // },
                    // { min: 10, message: 'Phone number must have 10 digits' },
                ]}
            >
                {/* <Input
                    placeholder="Phone number"
                    className={cx('item_input')}
                    maxLength={10}
                    onKeyDown={checkKeyDownNumberInput}
                /> */}

                <NumberInput inputClass={cx('item_input')}></NumberInput>
            </Form.Item>

            <Form.Item name="password" rules={[{ required: true, message: 'Please enter password' }]}>
                <Input.Password
                    placeholder="Password"
                    className={cx('item_input')}
                    maxLength={6}
                    onKeyDown={checkKeyDownNumberInput}
                    iconRender={(visible) =>
                        visible ? (
                            <EyeOutlined style={{ color: '#898989', fontSize: '22px' }} />
                        ) : (
                            <EyeInvisibleOutlined style={{ color: '#898989', fontSize: '22px' }} />
                        )
                    }
                />
            </Form.Item>

            <Row>
                <Col xs={12}>
                    {/* <Form.Item>
                        <Row justify="start">
                            <div className={cx('login-with-otp')} onClick={() => setStep(2)}>
                                Login with OTP
                            </div>
                        </Row>
                    </Form.Item> */}
                </Col>
                <Col xs={12}>
                    <Form.Item>
                        <Row justify="end">
                            <div className={cx('forgot_pass')} onClick={() => navigate(config.routes.forgotPassword)}>
                                Forgot password?
                            </div>
                        </Row>
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item>
                <button onClick={() => {}} className={cx('btn_login')}>
                    Log in
                </button>
            </Form.Item>

            <Row justify="center" className={cx('sign_in')}>
                Do not have an account? <span onClick={() => navigate(config.routes.register)}> Register</span>
            </Row>
        </Form>
    );
}

export default LoginWithPass;
